import { Box, CssBaseline } from '@mui/material';
import useInspection from 'hooks/useInspection';
import { memo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

function MindPage(): JSX.Element {
  const location = useLocation();
  const { isClassificationGuideStart1 } = useInspection();
  const validPaths = ['mind/classification'];
  const checkPath = validPaths.some(path => location.pathname.includes(path));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', overflowY: 'auto', height: '100vh', maxHeight: '100vh' }}>
      <CssBaseline />
      <Box sx={{ marginTop: 'auto', marginBottom: 'auto', width: '100%', flexShrink: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default memo(MindPage);
